// components/project-details/CustomerInfo.js
import React, { useState, useEffect } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import styles from './ProjectDetails.module.css';

const CustomerInfo = ({ customer, enquiryDetails, projectId, onCustomerUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedCustomer, setEditedCustomer] = useState({
    name: customer?.name || '',
    email: customer?.email || ''
  });

  useEffect(() => {
    setEditedCustomer({
      name: customer?.name || '',
      email: customer?.email || ''
    });
  }, [customer]);

  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'projects', projectId), {
        customerInfo: editedCustomer,
        updatedAt: new Date()
      });
      if (onCustomerUpdate) {
        onCustomerUpdate(editedCustomer);
      }
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating customer info:', error);
      alert('Failed to update customer information');
    }
  };

  const handleCancel = () => {
    setEditedCustomer({
      name: customer?.name || '',
      email: customer?.email || ''
    });
    setIsEditing(false);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--spacing-m)' }}>
        <h2 className={styles.sectionTitle}>Customer Information</h2>
        {!isEditing && (
          <button onClick={() => setIsEditing(true)} className={styles.editButton}>
            Edit
          </button>
        )}
      </div>
      
      {/* Profile Photo */}
      {enquiryDetails?.profilePhoto && (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--spacing-m)' }}>
          <img
            src={enquiryDetails.profilePhoto}
            alt={`${editedCustomer.name || 'Customer'} profile`}
            className={styles.profilePhoto}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}
      
      <div className={styles.infoGrid}>
        <div>
          <div className={styles.infoLabel}>Name</div>
          {isEditing ? (
            <input
              type="text"
              value={editedCustomer.name}
              onChange={(e) => setEditedCustomer({ ...editedCustomer, name: e.target.value })}
              className={styles.editableField}
              placeholder="Enter customer name"
            />
          ) : (
            <div className={styles.infoValue}>{customer?.name || 'Not provided'}</div>
          )}
        </div>
        <div>
          <div className={styles.infoLabel}>Email</div>
          {isEditing ? (
            <input
              type="email"
              value={editedCustomer.email}
              onChange={(e) => setEditedCustomer({ ...editedCustomer, email: e.target.value })}
              className={styles.editableField}
              placeholder="Enter customer email"
            />
          ) : (
            <div className={styles.infoValue}>{customer?.email || 'Not provided'}</div>
          )}
        </div>
      </div>

      {isEditing && (
        <div style={{ display: 'flex', gap: 'var(--spacing-xs)', justifyContent: 'flex-end', marginTop: 'var(--spacing-m)' }}>
          <button
            onClick={handleCancel}
            style={{
              padding: 'var(--spacing-xs) var(--spacing-m)',
              background: 'var(--Grey-100)',
              color: 'var(--Text-Primary)',
              border: 'none',
              borderRadius: 'var(--radius-xs)',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: 'var(--spacing-xs) var(--spacing-m)',
              background: 'var(--Blue-600)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--radius-xs)',
              cursor: 'pointer'
            }}
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
};

export default CustomerInfo;
